import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["allowedValuesSection", "valuesList"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.element.querySelector('input[name*="value_type"]:checked')
    if (!selected) return

    const show = selected.value === "list"
    this.allowedValuesSectionTarget.classList.toggle("d-none", !show)
  }

  addValue(event) {
    event.preventDefault()
    const template = document.createElement("div")
    template.classList.add("input-group", "mb-2")
    template.innerHTML = `
      <input type="text" name="chargebee_metadata_key[allowed_values][]" class="form-control" placeholder="Value">
      <button type="button" class="btn btn-outline-danger" data-action="chargebee-metadata-form#removeValue">
        <i class="fa fa-trash"></i>
      </button>
    `
    this.valuesListTarget.appendChild(template)
  }

  removeValue(event) {
    event.preventDefault()
    event.target.closest(".input-group").remove()
  }
}
